import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SharedModule } from 'src/app/shared/shared.module';
import { ButtonModule } from 'src/app/shared/form/button/button.module';
import { SelectModule } from 'src/app/shared/form/select/select.module';
import { SelLessonsEditorComponent } from './sel-lessons-editor.component';
import { TagfieldModule } from 'src/app/shared/form/tagfield/tagfield.module';
import { TextfieldComponent } from 'src/app/shared/form/textfield/textfield.component';
import { RichtextareaComponent } from 'src/app/shared/form/richtextarea/richtextarea.component';
import { ContentPickerModule } from 'src/app/shared/form/content-picker/content-picker.module';
import { WtdSectionModule } from 'src/app/shared/form/wtd-section/wtd-section.module';

@NgModule({
    declarations: [
        SelLessonsEditorComponent
    ],
    imports: [
        FormsModule,
        SharedModule,
        CommonModule,
        RouterModule,
        SelectModule,
        ButtonModule,
        TagfieldModule,
        TextfieldComponent,
        WtdSectionModule,
        RichtextareaComponent,
        ContentPickerModule,
    ],
})
export class SelLessonsEditorModule { }